import localforage from 'localforage';
import { StorageKeys } from 'shared/interfaces/InitProjectsPageOptions.ts';

/**
 * NOTE: `offlineDatabase` and `databaseCache` are also opened by the DB web workers
 * (see database/worker.ts, database/load.worker.ts) which call createOfflineDatabase()
 * without arguments. If you override those two names, the workers must be given the same
 * names or they will read/write a different store. The `projectsStore` is only used on the
 * main thread and is safe to override on its own.
 */
export const DEFAULT_STORAGE_KEYS: StorageKeys = {
    rootName: 'SaS',
    storeName: 'db',
    offlineDatabaseName: 'db',
    databaseCacheName: 'cache',
    projectsStoreName: 'projects',
};

export function createOfflineDatabase(storageKeys: Partial<StorageKeys> = {}): {
    offlineDatabase: LocalForage;
    databaseCache: LocalForage;
    projectsStore: LocalForage;
    userOptionsStore: LocalForage;
} {
    const {
        rootName,
        storeName,
        offlineDatabaseName,
        databaseCacheName,
        projectsStoreName,
    } = { ...DEFAULT_STORAGE_KEYS, ...storageKeys };

    localforage.config({
        driver: localforage.INDEXEDDB,
        name: rootName,
        storeName,
        description: 'SaS database',
    });
    return {
        offlineDatabase: localforage.createInstance({ name: offlineDatabaseName }),
        databaseCache: localforage.createInstance({ name: databaseCacheName }),
        projectsStore: localforage.createInstance({ name: projectsStoreName }),
        userOptionsStore: localforage.createInstance({ name: 'userOptions' }),
    };
}
